import { formatCicDateTime } from 'utils/cicReason';

import { EDIT_HISTORY_TITLE } from '../../LoanCicHistory.constants';

import { CHANGED_BY_PREFIX, EditedByPrefix } from './CicReasonCell.constants';

const getEditedBy = ({ editedByName, editedDate }) =>
  `${editedByName ?? ''} ${formatCicDateTime(editedDate)}`.trim();

export const getOriginalReasonSuffix = summary => ` · ${CHANGED_BY_PREFIX} ${getEditedBy(summary)}`;

export const getEditedByLabel = summary =>
  `${EditedByPrefix[summary.kind]} ${getEditedBy(summary)}`;

export const getEditHistoryLinkLabel = revisionsCount =>
  `${EDIT_HISTORY_TITLE} (${revisionsCount})`;
